import { Controller } from "@hotwired/stimulus"

const DEBOUNCE_MS = 400

// Connects to data-controller="filters"
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }

  debounceSubmit() {
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => this.submit(), DEBOUNCE_MS)
  }
}
